module.exports = __webpack_public_path__ + "img/concept_level_analysis.22decead.webp";